import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TabFrame.css';
import { 
    updateSelectedCategory1, 
    saveAll,
} from '../../actions/data';
import i18n from '../../i18n';
import TabContent from '../TabContent/TabContent.js';
import UnsubscribeAll from '../UnsubscribeAll/UnsubscribeAll.js';
import SavingMessage from '../SavingMessage/SavingMessage';

const CATEGORY1_HIDDEN = 'Hidden';

// Provides the frame for a 'Category1' from the Subscription Categories
class TabFrame extends PureComponent {

    constructor(props) {
        super(props);
        this.handleUpdateCategory1 = this.handleUpdateCategory1.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
    }

    handleUpdateCategory1(category1){
        this.props.updateSelectedCategory1(category1);
    }

    // save all the subscriptions
    handleSaveClick() {
        this.props.saveAll();
    }

    render() {

        const {
            data,
            params,
        } = this.props;

        // Map out the headers based on the cat1s. Hide all Headers if the 
        // First Cat1 is the hidden category
        const headers = data.category1s && data.category1s.length > 0 && data.category1s[0] !== CATEGORY1_HIDDEN ? 
                <div className='cat1-headers'>
                { data.category1s.map(category1 => {
                return (
                    <div
                        className={Classnames('cat1-header', { notSelected: category1 !== data.selectedCategory1 })}
                        onClick={this.handleUpdateCategory1.bind(this, category1)}
                        key={category1}
                    >
                        <h2>{category1}</h2>
                    </div>
                );
                }) 
            }
            </div> : null;

        const loadingMessage = !data.category1s ?
                <div className='loading-message'>
                    <div className='spinner'>
                        <FontAwesomeIcon icon="circle-notch" size="2x" style={{ color: '#5b6770' }} spin />
                    </div>
                    <div>
                        {i18n.t('loading-message')}
                    </div>
                </div>
                : 
                <div className='loading-message'>
                    <div>
                        {i18n.t('no-subs')}
                    </div>
                </div>;

        // Set up the footer
        const footer = data.footer ? 
                <div className='sub-footer' dangerouslySetInnerHTML={ {
                    __html: data.footer,
                } }>
                </div> : null;


        // Set up the SAVE and unsubscribe buttons
        const actionButtons = <div className='action-buttons'>
               
                {/* Show the Unsubscribe all button */}
                {!data.globalOptOutDate ? 
                    <UnsubscribeAll 
                        unsubscribe={params.unsubscribe}
                        colorGrey={params.showSave}
                    /> 
                : null }

                { params.showSave ?
                    <div className='save-button'>
                    <button
                            onClick={this.handleSaveClick}
                        >
                        {i18n.t('save')}
                    </button>
                    </div> : null
                }
        </div>
        
        return (
            // Lay out the headers and body sections
            data.category1s && data.category1s.length > 0 ?
                <div className="tab-frame">
                    
                    {/* Show headers */}
                    { headers }

                    {/* Show the Content for the tab. Uses Redux to get the selected Cat1 */}
                    <TabContent />

                    { /* Show the footer */}
                    { footer }

                    { /* Show the buttons */}
                    {actionButtons}

                    <SavingMessage saveInProgress={data.saveInProgress} saveFailed={data.saveFailed} saveColor={params.checkColorOn}/>
                </div>
                : [ loadingMessage ] 

        );
    }

}

function mapStateToProps(state) {
    return {
        data: state.data,
        params: state.params,
    };
}

export default connect(mapStateToProps,
    {
        updateSelectedCategory1,
        saveAll,
    })(TabFrame);
